import React, { useMemo } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';

import GlobalShortcutsComponent from '@atlassian/global-shortcuts';
import { TopLevelSpacer } from '@atlassian/navigation-system';
import { confluence } from '@atlassian/global-shortcuts/confluence';
import { loom } from '@atlassian/global-shortcuts/loom';
import { goals } from '@atlassian/global-shortcuts/goals';
import { projects } from '@atlassian/global-shortcuts/projects';
import { teams } from '@atlassian/global-shortcuts/teams';

import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import messages from './messages.tsx';

export function GlobalShortcuts() {
	const intl = useIntl();
	const cloudId = useCloudId();
	const { data: orgId } = useOrgId();

	// ShortcutItems needs to me memoized as intl triggers re-renders
	const shortcutItems = useMemo(() => {
		return [
			confluence(() => ''),
			loom(() => ''),
			goals(
				intl.formatMessage(messages.goalsShortcutText),
				() => 'https://home.atlassian.com/goals',
			),
			projects(
				intl.formatMessage(messages.projectsShortcutText),
				() => 'https://home.atlassian.com/projects',
			),
			teams(intl.formatMessage(messages.teamsShortcutText), () => '/jira/people/search'),
		];
	}, [intl]);

	return (
		<>
			<TopLevelSpacer />
			<GlobalShortcutsComponent
				cloudId={cloudId}
				orgId={orgId}
				useSkeleton
				promoteSite
				shortcutItems={shortcutItems}
				product="jira"
			/>
		</>
	);
}
